import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { ActionIcon, Button } from 'shared/ui';
import BallIcon from 'shared/ui/assets/icons/ball-icon.svg?react';
import { myBetsModalModel } from '../../model';

export const MyBetsModalButton = () => {
	const { t } = useTranslation();

	const open = useUnit(myBetsModalModel.myBetsSwitcher.enable);

	return (
		<Button
			variant='standard'
			leftSection={
				<ActionIcon
					variant='secondary'
					component='div'
				>
					<BallIcon />
				</ActionIcon>
			}
			onClick={open}
		>
			{t('my-bets-modal.button-label')}
		</Button>
	);
};
